export const setAuthData = (token, user) => ({
    type: 'SET_AUTH_DATA',
    payload: { token, user },
});

export const setUserData = (user) => ({
    type: 'SET_USER_DATA',
    payload: { user },
});

export const clearAuthData = () => ({
    type: 'CLEAR_AUTH_DATA',
});